var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { TreeRefService } from './tree-ref-service.interface';
let FocusNodeServiceImp = class FocusNodeServiceImp {
    constructor(_treeRefService) {
        this._treeRefService = _treeRefService;
        this._virtualSortTimer = 400; // 虚拟滚动组件排序重绘延迟时间为300ms
    }
    focusNode(node) {
        const selector = `[data-node-id="${node.id}"]`;
        const element = () => document.querySelector(selector);
        if (element()) {
            this._scrollIntoView(element);
            return;
        }
        const treeRef = this._treeRefService.getTreeRef();
        const index = _.findIndex(treeRef.flattenTree, { key: node.id });
        treeRef.$refs.virtualScrollerCompRef.scrollToItem(index + 1);
        this._scrollIntoView(element);
    }
    _scrollIntoView(element) {
        setTimeout(() => {
            requestAnimationFrame(() => {
                const node = element();
                node.scrollIntoView({
                    behavior: 'auto',
                    block: 'nearest',
                });
                this._tryFocusInput(node);
            });
        }, this._virtualSortTimer);
    }
    _tryFocusInput(element) {
        const input = element.querySelector('input');
        if (input instanceof HTMLInputElement) {
            input.focus();
        }
    }
};
FocusNodeServiceImp = __decorate([
    injectable(),
    __param(0, inject(TreeRefService)),
    __metadata("design:paramtypes", [typeof (_a = typeof TreeRefService !== "undefined" && TreeRefService) === "function" ? _a : Object])
], FocusNodeServiceImp);
export { FocusNodeServiceImp };
